/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Biaya_NInputs */

const en_mk_tut_biaya_n = /** @type {(inputs: Mk_Tut_Biaya_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For scale: one ordinary agent task runs Rp 130–500 and one chat message Rp 15–50. The Free plan gives 30 tasks a month, enough to prove whether this way of working fits.`)
};

const id_mk_tut_biaya_n = /** @type {(inputs: Mk_Tut_Biaya_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebagai gambaran: satu tugas agen biasa berkisar Rp 130–500 dan satu pesan chat Rp 15–50. Paket Gratis memberi 30 tugas per bulan, cukup untuk membuktikan apakah cara kerja ini cocok.`)
};

/**
* | output |
* | --- |
* | "For scale: one ordinary agent task runs Rp 130–500 and one chat message Rp 15–50. The Free plan gives 30 tasks a month, enough to prove whether this way of w..." |
*
* @param {Mk_Tut_Biaya_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_biaya_n = /** @type {((inputs?: Mk_Tut_Biaya_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Biaya_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_biaya_n(inputs)
	return en_mk_tut_biaya_n(inputs)
});